import { useGetCrucibleRecipesQuery, useGetCrucibleTemplatesQuery } from '@sorrem-client/ui/store';

/**
 * Loads the catalogs Character Home's tabs offer that never change during a
 * session, as soon as home opens, and keeps them while it stays open (#355):
 * the sizes of random crucible and the authored crucibles, so the Create
 * Crucible form opens with them in hand. Anything that changes with the
 * character is still fetched by the tab that shows it.
 */
export function usePreloadCharacterHomeCatalogs(): void {
    useGetCrucibleRecipesQuery();
    useGetCrucibleTemplatesQuery();
}
